import React from 'react';
import { Link } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';

function ValuationsLanding() {
    const styles = {
        linkPaper: {
            color: '#2C5591',
            textAlign: 'center' as const,
            padding: 50,
            fontSize: 14,
            margin: 20,
            width: 300,
        },
        flexContainer: {
            display: 'flex',
            flexDirection: 'row' as const,
            justifyContent: 'space-evenly' as const,
            overflow: 'auto',
        },
        verticalPadding: {
            paddingTop: 50,
            paddingBottom: 50,
        },
    };

    return (
        <>
            <div
                className='page-header'
                role='banner'
            >
                <h1>Valuations</h1>
            </div>
            <div
                className='row scrollable-content'
                style={styles.flexContainer}
            >
                <Link
                    to='/valuations/appraisers'
                    style={styles.verticalPadding}
                >
                    <Paper
                        style={styles.linkPaper}
                        elevation={3}
                    >
                        <h1>Appraisers</h1>
                        <p>Manage Appraisers.</p>
                    </Paper>
                </Link>
                <div className='columns small-12 large-12'>
                    <h2 className='decorated'> </h2>
                </div>
            </div>
        </>
    );
}

export default ValuationsLanding;
